import { ModalWindow, Ref, MultilineInput, Button } from "@tblabs/truffle";
import { PrimaryButton } from "../Components/PrimaryButton";
import { WatcherProfile } from "../Models/WatcherProfile";
import { Device } from "../Services/Device";


export class MessageToWatchersWindow extends ModalWindow
{
    constructor(device: Device, watcher: WatcherProfile)
    {
        super(`Message to Watcher-${watcher.Id}`, true, true, true);

        const message = new Ref<string>("");

        this.AddContent(
            new MultilineInput(message).Rows(6)
        );
        this.AddToFooter(
            new PrimaryButton("Send", () => device.SendMessageToWatcher(watcher.Id, message.value)).FloatLeft(),
            new Button("Close", () => this.CloseWindow())
        );

        this.OpenWindow();
    }
}
